import Vue from 'vue';
import { extend, ValidationProvider, setInteractionMode, ValidationObserver, configure } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import i18n from '@utils/localization';
import PhoneNumber from 'awesome-phonenumber';
import VTextFieldWithValidation from '@components/validators/VTextFieldWithValidation'
import VTextAreaWithValidation from '@components/validators/VTextAreaWithValidation'
import VRadioWithValidation from '@components/validators/VRadioWithValidation'
import VCheckboxWithValidation from '@components/validators/VCheckboxWithValidation'
import VSelectWithValidation from '@components/validators/VSelectWithValidation'
import VAutocompleteWithValidation from '@components/validators/VAutocompleteWithValidation'
// eslint-disable-next-line no-unused-vars
import rules from './rules';

configure({
  classes: {
    valid: 'myInput',
    invalid: 'myInputInvalid'
  }
});
setInteractionMode('passive');
extend('required', {
  ...required,
  message: 'Pole je povinné!'
});

extend('email', {
  ...email,
  message: 'Hodnota není validní e-mail!'
});

extend('password', {
  params: [{ name: 'target', isTarget: true }],
  validate(value, { target }) {
    return value === target;
  },
  message: () => i18n.t('common.PasswordsNotMatching')
});

extend('phone', {
  validate(value) {
    if (/[a-z]/i.test(value)) return false;
    const phone = new PhoneNumber(value);
    return phone.isValid();
  },
  // eslint-disable-next-line global-require
  message: () => i18n.t('common.NotAPhoneNumber')
});

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('VTextFieldWithValidation', VTextFieldWithValidation);
Vue.component('VTextAreaWithValidation', VTextAreaWithValidation);
Vue.component('VRadioWithValidation', VRadioWithValidation);
Vue.component('VCheckboxWithValidation', VCheckboxWithValidation);
Vue.component('VSelectWithValidation', VSelectWithValidation);
Vue.component('VAutocompleteWithValidation', VAutocompleteWithValidation);

export default {};
